import { schema as objectiveTypeBaseOffsetAccount } from './ObjectiveTypeBaseOffsetAccount.schema';
import { schema as objectiveTypeBaseRedraw } from './ObjectiveTypeBaseRedraw.schema';
import { labeled } from '../../util/joi';

export const schema = (Joi: any, label: string) =>
  Joi.object().keys({
    offsetAccount: objectiveTypeBaseOffsetAccount(Joi, labeled(label, 'Offset account -')),
    redraw: objectiveTypeBaseRedraw(Joi, labeled(label, 'Redraw -'))
  });

export default {
  schema
};
